/**
 * assets/collection-hub-section.js
 * Gedrag van sections/collection-hub.liquid
 *
 * Geknipt uit het {% javascript %}-blok van die section op 16-08-2026, 1:1.
 * Shopify plakte die blokken tot één compiled_assets/scripts.js dat op elke
 * pagina laadde, ook waar de section niet voorkwam. Nu laadt alleen deze
 * section zijn eigen gedrag. Zie ARCHITECTURE.md sectie 11.
 */

/*
 * Eenmalige uitvoering. Shopify voegde alle {% javascript %}-blokken samen tot
 * één bestand dat precies één keer draaide, ongeacht hoe vaak de section op de
 * pagina stond. Deze guard houdt dat gedrag exact gelijk nu elke section zijn
 * eigen script-tag rendert.
 */
(function () {
  'use strict';
  if (window.__vc_collectionHubSection) return;
  window.__vc_collectionHubSection = true;

  (function () {
    const listing = document.getElementById('collection-hub-listing');
    if (!listing) return;

    const wrapper = listing.closest('.shopify-section');
    let sectionId = 'main';
    if (wrapper && wrapper.id && wrapper.id.indexOf('shopify-section-') === 0) {
      sectionId = wrapper.id.slice('shopify-section-'.length);
    }

    const filterDialog = document.getElementById('filter-dialog');
    let priceDebounceTimer = null;

    function debouncedApplyFilters(source, delay) {
      clearTimeout(priceDebounceTimer);
      priceDebounceTimer = setTimeout(function () { applyFilters(source); }, delay || 800);
    }

    function bindFilterSearch() {
      listing.querySelectorAll('[data-filter-search]').forEach(function (input) {
        const groupKey = input.dataset.filterSearch;
        const list = listing.querySelector('[data-filter-list="' + groupKey + '"]');
        if (!list) return;
        input.addEventListener('input', function () {
          const query = input.value.toLowerCase().trim();
          list.querySelectorAll('[data-filter-value]').forEach(function (label) {
            const text = label.dataset.filterValue || '';
            label.style.display = (!query || text.indexOf(query) !== -1) ? '' : 'none';
          });
        });
      });
    }

    function bindDesktopInputs() {
      listing.querySelectorAll('[data-filter-input]').forEach(function (input) {
        if (input.type === 'number') {
          input.addEventListener('input', function () { debouncedApplyFilters('desktop'); });
        } else {
          input.addEventListener('change', function () { applyFilters('desktop'); });
        }
      });
      const sortSelect = listing.querySelector('[data-sort-select]');
      if (sortSelect) sortSelect.addEventListener('change', function () { applyFilters('desktop'); });
      const toggle = listing.querySelector('[data-filter-toggle]');
      if (toggle && filterDialog) toggle.addEventListener('click', function () { filterDialog.showModal(); });
      bindFilterSearch();
    }

    function bindMobileInputs() {
      if (!filterDialog) return;
      filterDialog.addEventListener('click', function (e) { if (e.target === filterDialog) filterDialog.close(); });
      filterDialog.querySelectorAll('[data-filter-input-mobile]').forEach(function (input) {
        input.addEventListener('change', function () { applyFilters('mobile'); });
      });
    }

    function bindLoadMore() {
      const btn = listing.querySelector('[data-load-more]');
      if (!btn) return;
      btn.addEventListener('click', async function () {
        const nextUrl = btn.dataset.nextUrl;
        if (!nextUrl) return;
        const textEl = btn.querySelector('[data-load-more-text]');
        const spinner = btn.querySelector('[data-load-more-spinner]');
        const icon = btn.querySelector('[data-load-more-icon]');
        if (textEl) textEl.textContent = 'Laden...';
        if (spinner) spinner.classList.remove('hidden');
        if (icon) icon.classList.add('hidden');
        btn.disabled = true;
        btn.classList.add('opacity-60');
        try {
          const separator = nextUrl.indexOf('?') !== -1 ? '&' : '?';
          const res = await fetch(nextUrl + separator + 'sections=' + sectionId);
          const json = await res.json();
          const html = json[sectionId];
          const tmp = document.createElement('div');
          tmp.innerHTML = html;
          const newGrid = tmp.querySelector('[data-product-grid-inner]');
          const newPagination = tmp.querySelector('[data-pagination-wrapper]');
          if (newGrid) {
            const currentGrid = listing.querySelector('[data-product-grid-inner]');
            const fragment = document.createDocumentFragment();
            Array.from(newGrid.children).forEach(function (child) { fragment.appendChild(child); });
            currentGrid.appendChild(fragment);
          }
          const currentPagination = listing.querySelector('[data-pagination-wrapper]');
          if (newPagination && currentPagination) {
            currentPagination.replaceWith(newPagination);
            bindLoadMore();
          } else if (currentPagination && !newPagination) {
            currentPagination.remove();
          }
          window.history.replaceState({}, '', nextUrl);
        } catch (err) {
          window.location.href = nextUrl;
        }
      });
    }

    async function applyFilters(source) {
      const form = source === 'mobile'
        ? document.querySelector('[data-filter-form-mobile]')
        : listing.querySelector('[data-filter-form]');
      const url = new URL(window.location.href);
      const params = new URLSearchParams();
      const currentSort = listing.querySelector('[data-sort-select]');
      if (currentSort && currentSort.value) params.set('sort_by', currentSort.value);
      if (form) {
        form.querySelectorAll('input[type="checkbox"]:checked').forEach(function (cb) { params.append(cb.name, cb.value); });
        form.querySelectorAll('input[type="number"], input[data-price-input]').forEach(function (input) { if (input.value) params.set(input.name, String(input.value).trim().replace(/\s/g, '').replace(',', '.')); });
      }
      const newUrl = url.pathname + '?' + params.toString();
      listing.style.opacity = '0.4';
      listing.style.transition = 'opacity 0.2s';
      try {
        const res = await fetch(newUrl + '&sections=' + sectionId);
        const json = await res.json();
        const html = json[sectionId];
        const tmp = document.createElement('div');
        tmp.innerHTML = html;
        const newListing = tmp.querySelector('#collection-hub-listing');
        if (newListing) {
          listing.innerHTML = newListing.innerHTML;
          window.history.pushState({}, '', newUrl);
          bindDesktopInputs();
          bindLoadMore();
        }
        listing.style.opacity = '1';
      } catch (err) {
        window.location.href = newUrl;
      }
    }

    bindDesktopInputs();
    bindMobileInputs();
    bindLoadMore();
    window.addEventListener('popstate', function () { window.location.reload(); });
  })();
})();
